<template>
    <CardShell>
        <Contact v-for="(thread, index) in threads" :key="thread.contact_id" @click="contactClick(index)" :isSelected="selectedIndex === index" :thread="thread" />
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import Contact from '@/components/inbox/contactsCard/Contact.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CardShell,
        Contact
    },
    data() {
        return {
            selectedIndex: 0
        };
    },
    computed: {
        ...mapState('messages', ['threads', 'contactId'])
    },
    methods: {
        contactClick(index) {
            if (this.$mq === 'xs' || this.$mq === 'sm') {
                this.$router.push({ path: '/messages-mobile' });
            } else {
                this.selectedIndex = index;
                this.$emit('selectedContactChanged', index);
            }
        }
    }
};
</script>
